import { gql } from "@apollo/client";

export const CreateGT = gql`
    mutation CreateGT($userRentingGroup: UserRentingGroupInput!) {
        createGT(userRentingGroup: $userRentingGroup)
    }
`; 